<h4 mat-dialog-title>Automate Campaign</h4>
<button class="close float-right" cdkFocusInitial mat-button (click)="dialogRef.close()">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <mat-slide-toggle labelPosition="before" color="primary" (change)="toggleChange($event)">
    I would like to automate this campaign
  </mat-slide-toggle>

  <mat-form-field appearance="fill" class="w-100 mt-3">
    <mat-label>Choose Frequency</mat-label>
    <mat-select #frequencyCtrl [value]="frequencyList[0]" [disabled]="!shouldAutomateCampaign">
      <mat-option *ngFor="let frequency of frequencyList" [value]="frequency">
        {{ frequency | titlecase }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" [mat-dialog-close]="shouldAutomateCampaign ? frequencyCtrl?.value : 'none'">
    Confirm
  </button>
</div>
